// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1179":"410088ecb49091c1","4439":"9ed3e6b6f28990b7","5801":"216ea294ef20b815","7744":"2141d7dc822f4ded","7746":"16f9ed5721018d06","9591":"cbe8704f09f817df","9860":"944b335ab8263da3"}[chunkId] + ".1782818277497.js";
};